<template>
    <div class="app-toast-container">
        <transition name="toast-animation">
            <div class="app-toast" v-if="toast">
                    <svg v-once class="app-toast__icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
                        <path d="M19.11,12.382c0.101-0.244,0.101-0.52,0-0.764c-0.051-0.123-0.124-0.233-0.217-0.326L14.05,6.449
                        c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L15.773,11H5.813c-0.552,0-1,0.447-1,1s0.448,1,1,1h9.96l-3.137,3.138
                        c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l4.843-4.844
                        C18.985,12.615,19.059,12.504,19.11,12.382z"/>
                    </svg>
                <app-icon class="app-toast__app-icon" :name="toast.icon" :tools="tools" />
                <div class="app-toast__text">{{ toast.title }}</div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'app-toasts',
        props: ['toasts', 'tools'],
        data() {
            return {
                toast: false
            }
        },
        watch: {
            toasts(toasts) {
                if (this.interval) {
                    clearInterval(this.interval);
                }

                this.toast = false;
                this.toast = toasts[0];
                this.interval = setInterval(() => {
                    this.toast = false;
                }, 1200);

            },
        },
    };
</script>

<style>
    .app-toast-container {
        position: fixed;
        bottom: 15px;
        left: 15px;
        z-index: 99;
        display: flex;
        flex-direction: column;
    }

    .app-toast-container .app-toast {
        margin-top: 10px;
    }

    .app-toast {
        background-color: rgba(0, 0, 0, .7);
        color: #FFF;
        display: inline-flex;
        padding: 8px 16px 8px 12px;
        font-weight: 500;
        font-size: 14px;
        border-radius: 8px;
        align-items: center;
    }

    .app-toast .app-toast__app-icon {
        margin-right: 10px;
        height: 18px;
        width: 18px;
    }

    .app-toast__icon {
        fill: rgba(255, 255, 255, .7);
        width: 30px;
        height: 26px;
    }

    .toast-animation-item {
      display: inline-block;
      margin-right: 10px;
    }
    .toast-animation-enter-active, .toast-animation-leave-active {
      transition: all 0.3s;
    }
    .toast-animation-enter, .toast-animation-leave-to /* .toast-animation-leave-active below version 2.1.8 */ {
      opacity: 0;
      transform: translateY(30px);
    }
</style>



// WEBPACK FOOTER //
// index.vue?4496515a